/* eslint-disable @nx/enforce-module-boundaries */
import { ActivatedRouteSnapshot, Route } from '@angular/router';

import { ClientConfigProductName } from '@frontend/vanilla/core';

import { SamePathAppVersion } from './app.version.enum';
import { allowedProductGuard, clientConfigAppGuard, hostAppMatchAppVersionGuard, matchAppVersionProductLoadGuard, ozoneProductGuard } from './guards';

const SPORTS_BETSTATION_ROUTES: Route[] = [];

export function serveModuleLoader(): any[] {
    switch (window && (window as any)['clientConfig']?.['haApp']?.['samePathAppVersions']?.['sports']) {
        case SamePathAppVersion.CORAL_MOBILE_APP:
            return [
                {
                    path: '',
                    loadChildren: () => import('@frontend/oxygen/cm-host-app').then((t) => t.CMHostAppModule),
                    canMatch: [allowedProductGuard, ozoneProductGuard],
                    data: { product: ClientConfigProductName.OZONE },
                },
            ];
        case SamePathAppVersion.CORAL_DESKTOP_APP:
            return [
                {
                    path: '',
                    loadChildren: () => import('@frontend/oxygen/cd-host-app').then((t) => t.CDHostAppModule),
                    canMatch: [allowedProductGuard, ozoneProductGuard],
                    data: { product: ClientConfigProductName.OZONE },
                },
            ];
        case SamePathAppVersion.LADBROKES_MOBILE_APP:
            return [
                {
                    path: '',
                    loadChildren: () => import('@frontend/oxygen/lm-host-app').then((t) => t.LMHostAppModule),
                    canMatch: [allowedProductGuard, ozoneProductGuard],
                    data: { product: ClientConfigProductName.OZONE },
                },
            ];
        case SamePathAppVersion.LADBROKES_DESKTOP_APP:
            return [
                {
                    path: '',
                    loadChildren: () => import('@frontend/oxygen/ld-host-app').then((t) => t.LDHostAppModule),
                    canMatch: [allowedProductGuard, ozoneProductGuard],
                    data: { product: ClientConfigProductName.OZONE },
                },
            ];
        case SamePathAppVersion.SPORTS_WEB_APP:
            return [
                {
                    path: '',
                    loadChildren: () => import('@frontend/sports/web/platform-lib/integration').then((t) => t.SportsWebIntegrationModule),
                    canMatch: [
                        allowedProductGuard,
                        (route: ActivatedRouteSnapshot) =>
                            matchAppVersionProductLoadGuard(ClientConfigProductName.SPORTS, SamePathAppVersion.SPORTS_WEB_APP, route),
                    ],
                    data: { product: ClientConfigProductName.SPORTS },
                },
            ];
        case SamePathAppVersion.SPORTS_BETSTATION_APP:
            return [
                {
                    path: '',
                    children: SPORTS_BETSTATION_ROUTES,
                    canMatch: [
                        allowedProductGuard,
                        () => hostAppMatchAppVersionGuard(ClientConfigProductName.SPORTS, SamePathAppVersion.SPORTS_BETSTATION_APP),
                    ],
                    canActivate: [clientConfigAppGuard],
                    data: { product: ClientConfigProductName.SPORTS },
                },
            ];
        default:
            return [];
    }
}
